/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2019, Zumper
 * @description saveSearchModal actions
 */

import type { Filters, Property, SaveSearchModal } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import {
  DONE_CREATING_SAVED_SEARCH,
  ERROR_CREATING_SAVED_SEARCH,
  RECEIVE_DATA,
  START_CREATING_SAVED_SEARCH,
} from '../constants/saveSearchModal'

export const startCreatingSavedSearch = createAction(START_CREATING_SAVED_SEARCH)
export const doneCreatingSavedSearch = createAction(DONE_CREATING_SAVED_SEARCH)
export const errorCreatingSavedSearch = createAction(ERROR_CREATING_SAVED_SEARCH)
export const receiveData = createAction<
  | {
      entity?: Property | null | undefined
      filters: Filters
      origin: Exclude<SaveSearchModal['origin'], ''>
    }
  | {
      entity: Property
      filters?: never
      origin: Exclude<SaveSearchModal['origin'], ''>
    },
  typeof RECEIVE_DATA
>(RECEIVE_DATA)
